module.exports = __webpack_public_path__ + "media/images/emblems/Mels-coat_of_arms-182088c569b55294de276c3b74c99caf.svg";